import {Component, Inject, OnInit} from '@angular/core';
import {Company} from '../../../../dto/company';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CompanyService} from '../../../services/company.service';
import {TemplateSendPreviewModel} from '../../../../models/template-send-preview-model';
import {CashbackGroupsService} from '../../../../cashback-groups.service';
import {CashbackGroup, CashbackGroupMembership} from '../../../../dto/cashbackGroup';
import {Card} from '../../../../dto/card';

@Component({
  selector: 'app-add-card-to-cashback-group-dialog',
  templateUrl: './add-card-to-cashback-group-dialog.component.html',
  styleUrls: ['./add-card-to-cashback-group-dialog.component.css']
})
export class AddCardToCashbackGroupDialogComponent implements OnInit {

  public title = 'Add card to cashback';
  public text = 'Please select the cashback group';


  public cashbackGroups: CashbackGroup[] = [];
  public cashbackGroup: CashbackGroup;
  public isLoadingCashbackGroups = false;

  public cashbackGroupId: number;
  public cardId: number;

  public card: Card;


  constructor(
    public dialogRef: MatDialogRef<AddCardToCashbackGroupDialogComponent>,
    private companiesService: CashbackGroupsService,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  private loadCashbackGroups() {
    this.isLoadingCashbackGroups = true;
    this.companiesService.getAll().subscribe(x => {
      this.cashbackGroups = x.data;
      if ( this.cashbackGroups.length > 0) {
this.cashbackGroup = this.cashbackGroups[0];
}
      this.isLoadingCashbackGroups = false;
    });
  }

  ngOnInit() {

    if (this.data != null && this.data as CashbackGroupMembership) {
      this.cardId = this.data.cardId || this.data.card?.id;
      this.card = this.data.card;
      this.cashbackGroupId = this.data.cashbackGroupId;
      this.loadCashbackGroups();
    }
  }

  onYesClick(): void {

    this.cashbackGroupId = this.cashbackGroup.id;

    const model = new CashbackGroupMembership();
    model.cashbackGroupId = this.cashbackGroupId;
    model.cardId = this.cardId;

    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

